import { GlobalConstantsTableCols } from "globales-projekt-angular";

export class ConstantsTableColsErgebnisTierplaetze extends GlobalConstantsTableCols {

  static readonly MODUL: string = 'MODUL';
  static readonly AUSGABE: string = 'AUSGABE';

  
  public static getColumns(anzahlGeb: number): string[] {
    let cols: string[] = [this.MODUL]; 
    for (let i = 0; i < anzahlGeb; i++) {
      cols.push(this.AUSGABE + "_" + i); 
    }
  
    return cols;
  }
}


